import Select from 'ol/interaction/Select';
import VectorSource from 'ol/source/Vector';

import { OverlayVectorLayer } from 'cadenza/map/interactions/overlay-vector-layer';
import type { Map } from 'cadenza/map/map';

import type { Feature } from 'ol';
import type { Options as SelectOptions } from 'ol/interaction/Select';
import type Layer from 'ol/layer/Layer';
import type { StyleLike } from 'ol/style/Style';

export type FeatureWithLayer = [Feature, Layer];

// Custom select interaction maintains custom vector layer overlay for the selection handles.
// It is rendered on top of the layer, so the handles are always on top.
// The overlay ignores the style of each individual feature and uses always layer style function, which produces a half-transparent only-selection style.
export class SelectOverlayInteraction extends Select {

  #overlay;
  /**
   * Used in patched Select interaction
   * @protected
   */
  additionalFeaturesFn;

  constructor (
    options: SelectOptions & { getSelectStyle: StyleLike },
    additionalFeaturesFn = (hitFeatures: FeatureWithLayer[])  => hitFeatures) {
    super({
      ...options,
      style: null
    });
    this.additionalFeaturesFn = additionalFeaturesFn;
    this.#overlay = new OverlayVectorLayer({
      source: new VectorSource({
        features: this.getFeatures()
      }),
      style: options.getSelectStyle,
      getMap: () => this.getMap()
    });
  }

  override setMap (map: Map) {
    super.setMap(map);
    this.#overlay.setMap(map);
  }

}
